<template>

    <Page class="text-lg !max-w-[80%]">

        <div>
            <h2 class="text-xl font-semibold">Stand Out with a Point of Difference</h2>
            <ul class="mt-1 list-disc text-white/60">
                <li class="pl-2 ml-5 mb-2 2xl:mb-4">
                    Carbucks REWARDS adds instant value to every car you sell — making your offer 
                    more attractive and helping you close deals faster. It's an easy way to make 
                    your pitch more compelling without discounting.
                </li>
            </ul>

            <h2 class="mt-6 text-xl font-semibold">Drive Loyalty and Repeat Business</h2>
            <ul class="mt-1 list-disc text-white/60">
                <li class="pl-2 ml-5 mb-2 2xl:mb-4">
                    Carbucks REWARDS opens a channel that keeps customers engaged with the dealership 
                    long after they drive away. When it's time for their next car, guess who 
                    they'll come back to?
                </li>
            </ul>

            <h2 class="mt-6 text-xl font-semibold">Boost Referrals and Your Reputation</h2>
            <ul class="mt-1 list-disc text-white/60">
                <li class="pl-2 ml-5 mb-2 2xl:mb-4">
                    Happy customers talk — and Carbucks REWARDS help them remember their high quality 
                    experience with you. That positive purchase and delivery experience ensures they'll 
                    refer friends and family back to you.
                </li>
            </ul>
        </div>

    </Page>

</template>